<template>
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
            <a-form layout="inline" @submit="submit" :autoFormCreate="(form) => {
                this.form = form;
            }
                ">
                <a-row :gutter="48">
                    <a-col>
                        <h2>
                            商品信息
                            <a-button @click="$refs.file.click()" style="float:right;">
                                <a-icon type="upload" />批量导入
                            </a-button>
                            <input type="file" ref="file" style="display: none" @change="upload" name="file" />
                        </h2>

                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="SPU" fieldDecoratorId="spu" :fieldDecoratorOptions="{
                            rules: [{ required: true, message: '请输入商品SPU' }],
                            initialValue: formData.spu,
                        }">
                            <a-input placeholder="SPU" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="商品名称" fieldDecoratorId="name" :fieldDecoratorOptions="{
                            rules: [{ required: true, message: '请输入商品名称' }],
                            initialValue: formData.name,
                        }">
                            <a-input placeholder="商品名称" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="供应商" fieldDecoratorId="supplier_id" :fieldDecoratorOptions="{
                            rules: [{ required: true, message: '请选择供应商' }],
                            initialValue: formData.supplier_id,
                        }">
                            <a-select placeholder="请选择供应商" allowClear show-search option-filter-prop="children">
                                <a-select-option v-for="d in suppliers" :key="d.id">{{ d.name }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="分类" fieldDecoratorId="goods_category_id" :fieldDecoratorOptions="{
                            rules: [{ required: true, message: '请选择供应商' }],
                            initialValue: formData.goods_category_id,
                        }">
                            <a-select placeholder="请选择供应商" allowClear show-search option-filter-prop="children">
                                <a-select-option v-for="d in categories" :key="d.id">{{ d.name }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="兑换规则" fieldDecoratorId="exchange_price" :fieldDecoratorOptions="{
                            rules: [{ required: true, message: '请输入兑换规则' }],
                            initialValue: formData.exchange_price,
                        }">
                            <a-input-number placeholder="兑换规则" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="成本价" fieldDecoratorId="cost_price" :fieldDecoratorOptions="{
                            rules: [{ required: true, message: '请输入成本价' }],
                            initialValue: formData.cost_price,
                        }">
                            <a-input-number placeholder="成本价" :step="1" :min="0.01" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="售价" fieldDecoratorId="retail_price" :fieldDecoratorOptions="{
                            rules: [{ required: true, message: '请输入售价' }],
                            initialValue: formData.retail_price,
                        }">
                            <a-input-number placeholder="售价" :step="1" :min="0.00" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="限购数量(跟随SPU)" fieldDecoratorId="limit_num" :fieldDecoratorOptions="{
                            initialValue: formData.limit_num,
                        }">
                            <a-input-number placeholder="限购数量" :step="1" :min="0" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="48">
                    <a-col :md="24" :sm="24">
                        <h2>商品规格</h2>
                    </a-col>
                    <a-col :md="24" :sm="24">
                        <a-form-item label="" fieldDecoratorId="sku" :fieldDecoratorOptions="{
                            rules: [{ required: true, validator: skuValidator }],
                            initialValue: formData.sku,
                        }">
                            <input type="hidden" />
                            <a-row :gutter="48" v-for="(i, index) in formData.sku" :key="index" style="height:184px">
                                <a-col :md="12" :sm="24" style="height:56px">
                                    <a-form-item required label="SKU">
                                        <a-input v-model="i.sku" />
                                    </a-form-item>
                                </a-col>
                                <a-col :md="12" :sm="24" style="height:56px">
                                    <a-form-item required label="69码">
                                        <a-input v-model="i.barcode69" />
                                    </a-form-item>
                                </a-col>
                                <a-col :md="12" :sm="24" style="height:56px">
                                    <a-form-item required label="规格">
                                        <a-input v-model="i.specification" />
                                    </a-form-item>
                                </a-col>
                                <a-col :md="8" :sm="24" style="height:128px">
                                    <a-form-item required label="SKU封面图">
                                        <a-upload name="file" listType="picture-card" class="avatar-uploader"
                                            :showUploadList="false" action="//upload.qiniup.com"
                                            :beforeUpload="beforeCoverUpload" :data="imgForm"
                                            @change="(info) => handleCoverChange(info, 'sku', index)">
                                            <img width="86" height="86" v-if="i.cover_img" :src="i.cover_img" />
                                            <div v-else>
                                                <a-icon :type="'plus'" />
                                                <div class="ant-upload-text">上传</div>
                                            </div>
                                        </a-upload>
                                    </a-form-item>
                                </a-col>
                                <a-col :md="4" :sm="24" style="height:56px">
                                    <a-button @click="delSku" style="float:right">删除</a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <a-col style="height:32px">
                            <a-button style="float:right" @click="addSKU">添加SKU</a-button>
                        </a-col>
                    </a-col>
                </a-row>
                <a-row :gutter="48">
                    <a-col :md="24" :sm="24">
                        <h2>图片信息</h2>
                    </a-col>
                    <a-col :md="8" :sm="24" style="height:128px">
                        <a-form-item label="商品列表图" fieldDecoratorId="list_img" :fieldDecoratorOptions="{
                            rules: [{ required: true, message: '请上传商品列表图' }],
                            initialValue: formData.list_img,
                        }">
                            <a-upload name="file" listType="picture-card" class="avatar-uploader" :showUploadList="false"
                                action="//upload.qiniup.com" :beforeUpload="beforeCoverUpload" :data="imgForm"
                                @change="(info) => handleCoverChange(info, 'list_img')">
                                <img width="86" height="86" v-if="formData.list_img" :src="formData.list_img" />
                                <div v-else>
                                    <a-icon :type="'plus'" />
                                    <div class="ant-upload-text">上传</div>
                                </div>
                            </a-upload>
                        </a-form-item>
                    </a-col>
                    <a-col :md="8" :sm="24" style="min-height:128px" class="slide-img">
                        <a-form-item label="轮播列表图" fieldDecoratorId="slide_img" :fieldDecoratorOptions="{
                            rules: [{
                                required: true, message: '请上传轮播列表图', validator: (rule, value, callback) => {
                                    value.length > 0 ? callback() : callback('请上传轮播图')
                                }
                            }],
                            initialValue: formData.slide_img,
                        }">
                            <div style="display:flex;flex-wrap: wrap">
                                <a-upload name="file" listType="picture-card" class="avatar-uploader"
                                    :showUploadList="false" action="//upload.qiniup.com" :beforeUpload="beforeCoverUpload"
                                    :data="imgForm" @change="(info) => handleCoverChange(info, 'slide_img')">
                                    <div>
                                        <a-icon :type="'plus'" />
                                        <div class="ant-upload-text">上传</div>
                                    </div>
                                </a-upload>
                                <div v-for="(i, index) in formData.slide_img" :key="index" class="img-box">
                                    <img width="102" height="102" :src="i" />
                                    <div class="del-img" @click="delImg(index)">
                                        <a-icon type="close" />
                                    </div>
                                </div>
                            </div>
                        </a-form-item>
                    </a-col>
                    <a-col :md="8" :sm="24" style="height:128px">
                        <a-form-item label="商品详情图" fieldDecoratorId="detail_img" :fieldDecoratorOptions="{
                            rules: [{ required: true, message: '请上传商品详情图' }],
                            initialValue: formData.detail_img,
                        }">
                            <a-upload name="file" listType="picture-card" class="avatar-uploader" :showUploadList="false"
                                action="//upload.qiniup.com" :beforeUpload="beforeCoverUpload" :data="imgForm"
                                @change="(info) => handleCoverChange(info, 'detail_img')">
                                <img width="86" height="86" v-if="formData.detail_img" :src="formData.detail_img" />
                                <div v-else>
                                    <a-icon :type="'plus'" />
                                    <div class="ant-upload-text">上传</div>
                                </div>
                            </a-upload>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-button type="primary" htmlType="submit" style="float:right">提交</a-button>
            </a-form>
        </div>
    </a-card>
</template>
<script>
import { getSupplierList } from "@/api/supplier";
import { getQiniuToken } from "@/api/qiniu";
import { saveMallGoods, getMallGoodsById } from "@/api/mall";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { getCategoryList } from '@/api/category'

const skuInfo = {
    id: 0,
    sku: "",
    specification: "",
    cover_img: "",
    barcode69: "",
}

const formDataInfo = {
    id: 0,
    spu: "",
    name: "",
    supplier_id: "",
    goods_category_id:"",
    exchange_price: "",
    cost_price: "",
    retail_price:"",
    limit_num: "",
    list_img: "",
    detail_img: "",
    sku: [],
    slide_img: [],
}

export default {
    data() {
        return {
            suppliers: [],
            categories: [],
            imgForm: {},
            loading: false,
            formData: {
                id: 0,
                spu: "",
                name: "",
                supplier_id: "",
                goods_category_id:"",
                exchange_price: "",
                cost_price: "",
                limit_num: "",
                list_img: "",
                detail_img: "",
                retail_price:"",
                sku: [
                    {
                        id: 0,
                        sku: "",
                        specification: "",
                        cover_img: "",
                        barcode69: "",
                    },
                ],
                slide_img: [],
            }
        }
    },
    watch: {
        "formData.sku": {
            handler(val) {
                this.form.setFieldsValue({ 'sku': val })
            },
            deep: true
        }
    },
    methods: {
        getCategoryList: function () {
            getCategoryList({ page_size: 10000 }).then(res => {
                this.categories = res.list
            })
        },
        upload(e) {
            let files = e.target.files;
            if (files.length > 0) {
                let data = new FormData();
                data.append("file", files[0]);
                fetch("/api/admin/mall/goods/batch", {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${this.$ls.get(ACCESS_TOKEN)}`,
                    },
                }).then((res) => {
                    if (res.status == 200) {
                        const a = document.createElement("a");
                        let filename = res.headers
                            .get("content-disposition")
                            .replace("attachment; filename=", "");
                        res.blob().then((blob) => {
                            a.href = URL.createObjectURL(blob);
                            a.download = decodeURIComponent(filename);
                            a.click();
                            URL.revokeObjectURL(a.href);
                        });
                    } else if (res.status == 401) {
                        res.json().then((data) => {
                            //token过期或者token错误会进入此处，需要将登录状态清除并要求重新登录
                            this.$message.error(`上传失败，${data.msg}`);
                        });
                    }
                });
            }
        },
        getMallGoodsByID(id) {
            this.loading = true
            getMallGoodsById(id)
                .then(res => {
                    let data = {
                        id: res.id,
                        spu: res.spu,
                        name: res.name,
                        supplier_id: res.supplier_id,
                        goods_category_id:res.goods_category_id,
                        exchange_price: res.exchange_price,
                        cost_price: res.cost_price,
                        limit_num: res.limit_num,
                        list_img: res.list_img,
                        detail_img: res.detail_img,
                        retail_price:res.retail_price/100,
                    }
                    data.sku = res.sku.map(item => {
                        return {
                            id: item.id,
                            sku: item.sku,
                            specification: item.specification,
                            cover_img: item.cover_img,
                            barcode69: item.barcode69,
                        }
                    })
                    data.slide_img = res.slide_img.map(item => {
                        return item.slide_img
                    })
                    this.formData = data
                    this.form.setFieldsValue(data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        submit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    let data = {
                        ...values,
                        list_img: this.formData.list_img,
                        detail_img: this.formData.detail_img,
                    }
                    if (this.formData.id) {
                        data.id = this.formData.id
                    }
                    if (this.loading) {
                        return
                    }
                    this.loading = true
                    saveMallGoods({
                        ...data,
                        retail_price: data.retail_price * 100,
                    })
                        .then(res => {
                            this.$message.success('保存成功')
                            this.formData = {
                                ...formDataInfo
                            }
                            this.formData.sku = [
                                {
                                    ...skuInfo
                                }
                            ]
                            this.formData.slide_img = []
                            this.form.resetFields()
                            if (this.$route.name == 'mallGoodsEdit') {
                                this.$router.push({ name: 'mallGoods' })
                            }
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            })
        },
        beforeCoverUpload() {
            let _this = this;
            return getQiniuToken().then((res) => {
                _this.bucketHost = res.bucket_host;
                _this.imgForm = {
                    token: res.qiniu_token,
                };
            });
        },
        handleCoverChange(info, type, index) {
            if (info.file.status === "uploading") {
                // this.loading = true;
            } else if (info.file.status === "done") {
                let key = info.file.response.key;
                let url = `${this.bucketHost}${key}`
                // this.pic_url = `${this.bucketHost}${key}`;
                // this.loading = false;
                if (type == 'sku') {
                    this.formData.sku[index].cover_img = url
                } else if (type == "slide_img") {
                    this.formData.slide_img.push(url)
                    this.form.setFieldsValue({
                        slide_img: this.formData.slide_img
                    })
                } else if (type == "list_img") {
                    this.formData.list_img = url
                } else if (type == "detail_img") {
                    this.formData.detail_img = url
                }
            } else if (info.file.status === "error") {
                // this.loading = false;
                this.$message.error("上传图片失败，请重试");
            } else if (info.file.status === "removed") {
                console.log("removed");
            }
        },
        addSKU() {
            this.formData.sku.push({ ...skuInfo })
        },
        delSku(index) {
            if (this.formData.sku.length > 1) {
                this.formData.sku.splice(index, 1)
            }
        },
        delImg(index) {
            this.formData.slide_img.splice(index, 1)
            this.form.setFieldsValue({
                slide_img: this.formData.slide_img
            })
        },
        skuValidator(rule, value, callback) {
            if (value.length > 0) {
                if (value.some(item => !item.sku)) {
                    callback("请填写sku")
                } else if (value.some(item => !item.specification)) {
                    callback("请填写规格")
                } else if (value.some(item => !item.cover_img)) {
                    callback("请上传封面图")
                } else if (value.some(item => !item.barcode69)) {
                    callback("请填写69码")
                } else {
                    callback()
                }
            } else {
                callback("请填写sku信息")
            }
        },
    },
    created() {
        if (this.$route.name == 'mallGoodsEdit') {
            this.getMallGoodsByID(this.$route.params.id)
        }
        getSupplierList().then(res => {
            this.suppliers = res.list
        })
        this.getCategoryList()
    }
}
</script>
<style lang="less">
.slide-img .ant-form-item-control {
    height: auto !important;

    .img-box {
        margin-right: 8px;
        margin-bottom: 8px;
        position: relative;

        .del-img {
            position: absolute;
            top: -10px;
            right: -10px;
            background: rgba(0, 0, 0, .45);
            color: #fff;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            border-radius: 50%;
            cursor: pointer;
        }
    }
}
</style>